<template>
  <div>
    <v-tabs
      v-model="tab"
      slider-color="primary"
      class="rounded-lg"
      centered
      show-arrows
    >
      <v-tab class="text-h5 font-weight-bold primary--text">SIGN IN</v-tab>
      <v-tab
        v-if="allowCreateAccount"
        class="text-h5 font-weight-bold primary--text"
        >CREATE ACCOUNT</v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-alert
        :value="authError != null"
        type="error"
        transition="fade-transition"
        dismissable
      >
        {{ authError }}
      </v-alert>
      <v-tab-item> <sign-in-form /> </v-tab-item>
      <v-tab-item v-if="allowCreateAccount">
        <create-account-form />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import { state, getters } from '@/store/modules/auth/types';
import SignIn from './SignIn.vue';
import CreateAccount from './CreateAccount.vue';

export default {
  components: {
    signInForm: SignIn,
    createAccountForm: CreateAccount,
  },
  data() {
    return {
      tab: null,
      allowCreateAccount: false,
    };
  },
  computed: {
    ...mapState('auth', {
      authError: state.AUTH_ERROR,
    }),
    ...mapGetters('auth', {
      isUserAuthenticated: getters.IS_USER_AUTHENTICATED,
    }),
  },

  async created() {
    const { data } = await axios.get('/auth/signup_enabled');
    this.allowCreateAccount = data.enabled;
  },
};
</script>

<style scoped></style>
